function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "74C5A55E-FD65-4907-92E1-9AAC3BAD4F96");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Kronos_Style-guide_3",
  transform: "translate(-544.000000, -344.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-22",
  transform: "translate(100.000000, 100.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-21",
  transform: "translate(0.000000, 144.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-14",
  transform: "translate(0.000000, 100.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-13",
  transform: "translate(120.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "24px_67",
  transform: "translate(324.000000, 0.000000)"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 24 0 24 24 0 24"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22,10.4112828 L22,3.69873596 L15.2134079,3.69873596 L15.2134079,6.58684457 L12.2275228,6.58684457 L12.2275228,2 L2,2 L2,12.1102528 L6.64572459,12.1102528 L6.64572459,15.2874532 L3.72069942,15.2874532 L3.72069942,22 L10.5070574,22 L10.5070574,15.2872191 L7.58203226,15.2872191 L7.58203226,12.1102528 L11.5938765,12.1102528 L13.8267363,14.3148408 L11.7584326,16.3569757 L16.5614569,21.099485 L21.3647152,16.3569757 L16.5614569,11.6144663 L14.4931533,13.6566011 L12.2275228,11.4194757 L12.2275228,7.52317416 L15.2134079,7.52317416 L15.2134079,10.4112828 L22,10.4112828 Z M9.57074975,21.0636704 L4.65700709,21.0636704 L4.65700709,16.2235487 L9.57074975,16.2235487 L9.57074975,21.0636704 Z M20.0318813,16.3569757 L16.5612228,19.7837079 L13.0910325,16.3569757 L16.5612228,12.9302434 L20.0318813,16.3569757 Z M11.2912151,11.1739232 L2.93630767,11.1739232 L2.93630767,2.93632959 L11.290981,2.93632959 L11.290981,11.1739232 L11.2912151,11.1739232 Z M16.1497156,4.63506554 L21.0636923,4.63506554 L21.0636923,9.47518727 L16.1497156,9.47518727 L16.1497156,4.63506554 Z",
  id: "Shape",
  stroke: "currentColor",
  strokeWidth: 0.4,
  fill: "currentColor",
  fillRule: "nonzero"
}))))))));

var SvgConnection = function SvgConnection(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgConnection, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/connection.ae8e3d97.svg";
export { ForwardRef as ReactComponent };